import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/employee-course-table-store';

const EmployeeCourseTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default EmployeeCourseTableContextWrapper;
